import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../../urls";

export const LegacyWizardRedirect = () => {
  const { eventId } = useParams();
  const location = useLocation();
  if (!eventId) return <Navigate to={urls.app.sourcingEvents.viewAll} replace />;
  const { pathname } = urls.app.sourcingEvents.edit.go(eventId).info;
  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};
